import React, { useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import ServiceCategoryPieChartHbb from "./serviceCategoryPieChartHbb";

am4core.useTheme(am4themes_animated);

export default function EbuCbuPieChartTwoHbb(props) {
  const [showServiceChart, setShowServiceChart] = useState(false);
  const { onClick, label, text } = props;

  useLayoutEffect(() => {
    const chart = am4core.create(props?.id ?? "chartdiv95", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    chart.data = label;

    // Add and configure Series
    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";

    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(40);

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;

    pieSeries.slices.template.events.on("hit", function (ev) {
      onClick(ev.target.dataItem.properties.category);
    });

    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;

    if (props?.total) {
      let totalLabel = chart.createChild(am4core.Label);
      totalLabel.text = `Total: ${props?.total}`;
      totalLabel.fontSize = 20;
      totalLabel.align = "center";
      totalLabel.isMeasured = false;
      totalLabel.x = am4core.percent(50);
      totalLabel.horizontalCenter = "middle";
      totalLabel.y = am4core.percent(46);
      totalLabel.clickable = true;
      totalLabel.events.on("hit", () =>
        props?.total > 0 ? props?.onClickText() : null
      );
      totalLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    }

    let totalLabel = chart.createChild(am4core.Label);
    totalLabel.text = text;
    totalLabel.fontSize = 20;
    totalLabel.align = "center";

    /// Chart 2

    // const chartCbu = am4core.create("chartdiv96", am4charts.PieChart);
    // chartCbu.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    // // Add and configure Series
    // var pieSeriesCbu = chartCbu.series.push(new am4charts.PieSeries());
    // pieSeriesCbu.dataFields.value = "litres";
    // pieSeriesCbu.dataFields.category = "country";

    // // Let's cut a hole in our Pie chart the size of 40% the radius
    // chartCbu.innerRadius = am4core.percent(40);

    // // Set up fills
    // pieSeriesCbu.slices.template.fillOpacity = 1;

    // pieSeriesCbu.slices.template.events.on("hit", function (ev) {
    //   onNext(ev.target.dataItem.properties.category);
    // });

    // var hs = pieSeriesCbu.slices.template.states.getKey("hover");
    // hs.properties.scale = 1;
    // hs.properties.fillOpacity = 0.5;

    // let totalLabelCBU = chartCbu.createChild(am4core.Label);
    // totalLabelCBU.text = text;
    // totalLabelCBU.fontSize = 20;
    // totalLabelCBU.align = "center";

    return () => {
      chart.dispose();
      // chartCbu.dispose();
    };
  }, []);

  if (showServiceChart) {
    return <ServiceCategoryPieChartHbb />;
  }

  return (
    <div
      style={{
        width: props?.width ?? "100%",
        height: "500px",
        direction: "ltr",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      }}
    >
      {/* <div
        id="chartdiv96"
        style={{ width: "45%", height: "350px", direction: "ltr" }}
      /> */}
      <div
        id={props?.id ?? "chartdiv95"}
        style={{
          width: "100%",
          height: props?.height ?? "350px",
          direction: "ltr",
        }}
      />
    </div>
  );
}
